import ProductTable from "../components/Dashboard/ProductTable.js";
import Search from "../components/Dashboard/Search.js";

function ProductsListView() {
    return(
        <div className="dashboard-wrapper">
            <div className="dashboard-header">
                <div className="actions-row">
                    <div className="actions-group"></div>
                    <div className="actions-group">
                        <Search />
                    </div>
                </div>
            </div>

            <div className="dashboard-body">
                <h1 className="dashboard-title">PRODUCTS</h1>
                <ProductTable dashboard={false} />
            </div>
        </div>
    );
}

export default ProductsListView;